import { oldColors } from './_delete_later';

export const color = {
    peach: {
        /** rgb(255, 248, 245) */
        50: 'rgb(255, 248, 245)',
        /** rgb(255, 228, 219) */
        100: 'rgb(255, 228, 219)',
        /** rgb(255, 190, 168) */
        200: 'rgb(255, 190, 168)',
        /** rgb(255, 152, 117) */
        300: 'rgb(255, 152, 117)',
        /** rgb(255, 113, 66) */
        400: 'rgb(255, 113, 66)',
        /** rgb(255, 80, 22) — default */
        500: 'rgb(255, 80, 22)',
        /** rgb(233, 58, 0) */
        600: 'rgb(233, 58, 0)',
        /** rgb(189, 47, 0) */
        700: 'rgb(189, 47, 0)',
        /** rgb(146, 36, 0) */
        800: 'rgb(146, 36, 0)',
        /** rgb(102, 26, 0) */
        900: 'rgb(102, 26, 0)',
    },
    red: {
        /** rgb(253, 247, 247) */
        50: 'rgb(253, 247, 247)',
        /** rgb(247, 227, 228) */
        75: 'rgb(247, 227, 228)',
        /** rgb(240, 204, 205) */
        100: 'rgb(240, 204, 205)',
        /** rgb(226, 153, 155) */
        200: 'rgb(226, 153, 155)',
        /** rgb(211, 102, 105) */
        300: 'rgb(211, 102, 105)',
        /** rgb(197, 51, 55) */
        400: 'rgb(197, 51, 55)',
        /** rgb(182, 0, 5) — default */
        500: 'rgb(182, 0, 5)',
        /** rgb(146, 0, 4) */
        600: 'rgb(146, 0, 4)',
        /** rgb(109, 0, 3) */
        700: 'rgb(109, 0, 3)',
        /** rgb(73, 0, 2) */
        800: 'rgb(73, 0, 2)',
        /** rgb(36, 0, 1) */
        900: 'rgb(36, 0, 1)',
    },
    green: {
        /** rgb(219, 255, 232) */
        100: 'rgb(219, 255, 232)',
        /** rgb(128, 255, 174) */
        200: 'rgb(128, 255, 174)',
        /** rgb(77, 255, 142) */
        300: 'rgb(77, 255, 142)',
        /** rgb(26, 255, 109) */
        400: 'rgb(26, 255, 109)',
        /** rgb(230, 255, 239) */
        50: 'rgb(230, 255, 239)',
        /** rgb(0, 230, 84) — default */
        500: 'rgb(0, 230, 84)',
        /** rgb(0, 178, 65) */
        600: 'rgb(0, 178, 65)',
        /** rgb(0, 128, 47) */
        700: 'rgb(0, 128, 47)',
        /** rgb(0, 77, 28) */
        800: 'rgb(0, 77, 28)',
        /** rgb(0, 26, 9) */
        900: 'rgb(0, 26, 9)',
    },
    yellow: {
        /** rgb(255, 206, 26) */
        50: 'rgb(255, 250, 229)',
        /** rgb(255, 246, 213) */
        100: 'rgb(255, 246, 213)',
        /** rgb(255, 239, 179) */
        200: 'rgb(255, 239, 179)',
        /** rgb(255, 228, 128) */
        300: 'rgb(255, 228, 128)',
        /** rgb(255, 206, 26) */
        400: 'rgb(255, 206, 26)',
        /** rgb(230, 180, 0) — default */
        500: 'rgb(230, 180, 0)',
        /** rgb(179, 140, 0) */
        600: 'rgb(179, 140, 0)',
        /** rgb(128, 100, 0) */
        700: 'rgb(128, 100, 0)',
        /** rgb(77, 60, 0) */
        800: 'rgb(77, 60, 0)',
        /** rgb(26, 20, 0) */
        900: 'rgb(26, 20, 0)',
    },
    blue: {
        /** rgb(229, 243, 255) */
        50: 'rgb(229, 243, 255)',
        /** rgb(179, 219, 255) */
        100: 'rgb(179, 219, 255)',
        /** rgb(128, 195, 255) */
        200: 'rgb(128, 195, 255)',
        /** rgb(77, 171, 255) */
        300: 'rgb(77, 171, 255)',
        /** rgb(26, 147, 255) */
        400: 'rgb(26, 147, 255)',
        /** rgb(0, 112, 212) — default */
        500: 'rgb(0, 112, 212)',
        /** rgb(0, 94, 179) */
        600: 'rgb(0, 94, 179)',
        /** rgb(0, 67, 128) */
        700: 'rgb(0, 67, 128)',
        /** rgb(0, 40, 77) */
        800: 'rgb(0, 40, 77)',
        /** rgb(0, 13, 26) */
        900: 'rgb(0, 13, 26)',
    },
    grey: {
        /** rgb(250, 250, 250) */
        50: 'rgb(250, 250, 250)',
        /** rgb(237, 237, 237) */
        75: 'rgb(237, 237, 237)',
        /** rgb(204, 204, 204) */
        100: 'rgb(204, 204, 204)',
        /** rgb(179, 179, 179) */
        200: 'rgb(179, 179, 179)',
        /** rgb(153, 153, 153) */
        300: 'rgb(153, 153, 153)',
        /** rgb(128, 128, 128) */
        400: 'rgb(128, 128, 128)',
        /** rgb(102, 102, 102) — default */
        500: 'rgb(102, 102, 102)',
        /** rgb(77, 77, 77) */
        600: 'rgb(77, 77, 77)',
        /** rgb(51, 51, 51) */
        700: 'rgb(51, 51, 51)',
        /** rgb(26, 26, 26) */
        800: 'rgb(26, 26, 26)',
        /** rgb(0, 0, 0) */
        900: 'rgb(0, 0, 0)',
    },
    unsorted: {
        /** rgb(21, 93, 252) */
        anchorBlue: 'rgb(21, 93, 252)',
    },
    // TODO: Remove old color palette after migrating all components to new palette
    // To Claude: DON'T USE THESE!
    ...oldColors,
};
